// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import vuexI18n from 'vuex-i18n';
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
// import Router from 'vue-router'
import {store} from './store'
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import FullCalendar from 'vue-full-calendar';
import VueApexCharts from 'vue-apexcharts'
import 'fullcalendar/dist/fullcalendar.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en';
import frLocale from 'element-ui/lib/locale/lang/fr';
import Keycloak from 'keycloak-js';
import api from './api/'

locale.use(frLocale)
Vue.use(vuexI18n)
Vue.use(FullCalendar)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

Vue.use(ElementUI, { frLocale});
Vue.use(VueGoodTablePlugin);
window.store = store
//import axios from 'axios';
// axios.defaults.baseURL = 'https://posteoneservice.herokuapp.com/api'
// window.authStr = 'Bearer '.concat(localStorage.getItem('token'));
// todo
// cssVars()
//window.axios = axios
Vue.use(BootstrapVue)
//Vue.use(axios)
// const routes = new Router({
//   router,
// })

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters['auth/loggedIn']) {
      next({
        name: 'Login',
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },

})

// let initOptions = {
//   url: 'http://192.168.56.1:8180/auth', realm: 'PosteSenegal', clientId: 'posteone', onLoad: 'login-required'
// }

// let keycloak = Keycloak(initOptions);

// keycloak.init({ onLoad: initOptions.onLoad }).success(async(auth) => {

//   if (!auth) {
//     window.location.reload();
//   } else {
//     // Vue.$log.info("Authenticated");
//     console.log('Authenticated')
//   }

//     localStorage.setItem("token", keycloak.token);
//     localStorage.setItem("vue-refresh-token", keycloak.refreshToken);
    
//     let token = localStorage.getItem('token')
//     // let perm = await api.auth.getUserPermissions(token)
//     // let role = await api.role.get_auth_roles(token)
//     // let user = await api.user.get_auth_users(token)
//     // localStorage.setItem('name', user.data.data.name)
//     // localStorage.setItem('role', role.data.data)

//     //console.log(perm.data.data)
//     router.beforeEach((to, from, next) => {
//     if (to.matched.some(record => record.meta.requiresAuth)) {
//       // this route requires auth, check if logged in
//       // if not, redirect to login page.
//       if (!token) {
//         next({
//           name: 'Keycloak',
//         })
//       } else {
//         next()
//       }
//     } else {
//       next() // make sure to always call next()!
//     }
//   })
//   new Vue({
//     el: '#app',
//     router,
//     store,
//     template: '<App/>',
//     components: {
//       App
//     },
//   })


  
//   setTimeout(() => {
//     keycloak.updateToken(70).success((refreshed) => {
//       if (refreshed) {
//         console.log('Token refreshed' + refreshed);
//       } else {
//         console.log('Token not refreshed, valid for '
//           + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
//       }
//     }).error(() => {
//       console.error('Failed to refresh token');
//     });
//   }, 60000)

// }).error(() => {
//   console.error("Authenticated Failed : ");
// });

